<script>
import { mapState, mapActions } from 'vuex';
import ItinerarySeoTeaserList from '../../components/itinerary/ItinerarySEOTeaserList';

export default {
  name: 'ItineraryEditSEO',
  components: {
    ItinerarySeoTeaserList,
  },
  data() {
    return {
      itineraryId: null,
      showLocationModal: false,
      showImageModal: false,
    };
  },
  computed: {
    ...mapState({
      seoLoading: state => state.itinerary.seoTeasers.loading,
      seoError: state => state.itinerary.seoTeasers.error,
      seoItems: state => state.itinerary.seoTeasers.items,
      selectedDomain: state => state.itinerary.domains.selected,
      itinerary: state => state.itinerary.edit.item,
    }),
  },
  methods: {
    ...mapActions({
      getSeoTeaserEntries: 'itinerary/getSeoTeaserEntries',
      updateSeoTeaserEntry: 'itinerary/updateSeoTeaserEntry',
      getCountriesWithAreasByProductTypeId: 'itinerary/getCountriesWithAreasByProductTypeId',
      updateItineraryDomains: 'itinerary/updateItineraryDomains',
    }),
    saveTeasers(data) {
      const payload = {
        itineraryId: this.itineraryId,
        data,
      };
      this.updateSeoTeaserEntry(payload);
    },
    updateItineraryDomain(event) {
      this.updateItineraryDomains({
        itineraryId: this.$route.params.id,
        itineraryDomains: [event],
      });
    },
  },
  created() {
    this.itineraryId = +this.$route.params.id;
    this.getSeoTeaserEntries(this.itineraryId);
    this.getCountriesWithAreasByProductTypeId(this.itinerary.productTypeId);
  },
};
</script>

<template>
  <div>
    <itinerary-seo-teaser-list
      :itinerary-id="itineraryId"
      :seo-loading="seoLoading"
      :seo-error="seoError"
      :seo-teaser-items="seoItems"
      :selected-domain="selectedDomain"
      @saveTeasers="saveTeasers"
      @updateDomain="updateItineraryDomain"
    />
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/itinerary/ItineraryEditSEO.vue